import React from 'react';
import { Button, Spinner } from 'tuui';
import { INDICATION_TYPES, OkOIcon } from 'taboola-ultimate-ui';
import { OutlineEditableText } from 'modules/campaigns/components';
import { urlValidations } from 'modules/campaigns/config';
import { useUrlValidatedInput } from 'modules/campaigns/modules/creative-creator/components/UrlList/useUrlValidatedInput';
import { withIndication } from 'modules/errors';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useGetPixelTesterUrl } from '../../../hooks/useGetPixelTesterUrl';
import styles from './UrlInputWithValidation.module.scss';

const OutlineEditableTextWithIndication = withIndication(OutlineEditableText);

export const UrlInputWithValidation = ({ validations: validationsProp = urlValidations }) => {
    const {
        cacheValue: websiteUrl,
        onChange,
        onBlur,
        showSuccessIcon,
        isValidationsRunning,
        indicationData,
    } = useUrlValidatedInput({
        field: 'pixelTesterWebsiteUrl',
        validations: validationsProp,
    });
    const getPixelTesterUrl = useGetPixelTesterUrl(websiteUrl);
    const { formatMessage } = useIntl();
    const isPixelNotFoundError = indicationData?.message?.props?.id === 'validations.error.field.url.pixel';
    const disableQrCodeButton =
        (indicationData.indicationType === INDICATION_TYPES.ERROR && !isPixelNotFoundError) || isValidationsRunning;

    return (
        <>
            <OutlineEditableTextWithIndication
                id="url-input"
                value={websiteUrl}
                onChange={onChange}
                onBlur={onBlur}
                className={styles['url-input-item']}
                inputClassName={styles['url-input']}
                placeholder={formatMessage({
                    id: 'pixel.tester.website.url.placeholder',
                    defaultMessage: 'Enter your URL',
                })}
                data-metrics-event-name={GTM_EVENTS.USABILITY}
                data-metrics-component={UrlInputWithValidation.name}
                data-metrics-value={`PIXEL_TESTER_URL_INPUT_${websiteUrl}`}
                blurOnEnter
                {...indicationData}
            >
                {showSuccessIcon && (
                    <OkOIcon data-testid="okIcon" className={styles['success-icon']} aria-label="Validated url icon" />
                )}
            </OutlineEditableTextWithIndication>
            {isValidationsRunning && (
                <div className={styles['validation-container']}>
                    <Spinner size={14} className={styles['spinner']} />
                    <FormattedMessage
                        id="pixel.tester.validating.url"
                        className={styles['validation-text']}
                        defaultMessage="Validating URL..."
                    />
                </div>
            )}
            <Button
                className={styles['test-events-button']}
                id="PIXEL_TESTER_GENERATE_QR_CODE_BTN"
                variant={Button.variant.primary}
                aria-label="Generate QR Code"
                disabled={disableQrCodeButton}
                onClick={getPixelTesterUrl}
                data-metrics-event-name={GTM_EVENTS.USABILITY}
                data-metrics-component={UrlInputWithValidation.name}
                data-metrics-value={`PIXEL_TESTER_GENERATE_QR_CODE_${websiteUrl}`}
            >
                <FormattedMessage id="pixel.tester.website.generate-qr-code.button" defaultMessage="Generate QR Code" />
            </Button>
        </>
    );
};
